import * as React from 'react';
import { css } from '@emotion/react';

// These are the styles for the HubSpot forms on the /contact-us, /schedule-demo, and /get-quote pages
const formStyles = css`
  .dont-delete-this-class {
    color: var(--color-error);
  }

  .hs-input {
    width: 100% !important;
  }

  .form-columns-1,
  .form-columns-2,
  .form-columns-3 {
    max-width: none !important;
    margin-top: 1rem;
  }

  .form-columns-0 {
    max-width: none;
  }

  @media only screen and (min-width: 480px) {
    .hs_aci_4432_edg_1,
    .hs_aci_4034 {
      width: 32.7% !important;
      float: left !important;
    }
  }

  .hs-field-desc {
    font-size: 0.875rem;
    line-height: 1.25rem;
    color: var(--color-base-content);
  }

  .hs-form-required {
    color: var(--color-info);
  }

  .hs-error-msg {
    font-weight: 400;
    color: var(--color-error);
    margin-top: 0;
  }

  .hs-recaptcha {
    margin-top: 1rem;
    margin-bottom: 2rem;
  }

  .grecaptcha-badge {
    margin-left: auto;
    margin-right: auto;
  }

  label {
    font-family: 'Red Hat Display', sans-serif;
    box-sizing: border-box;
    border-width: 0;
    border-style: solid;
    border-color: var(--color-base-200);
    display: block;
    font-size: 0.875rem;
    font-weight: 600;
    line-height: 1.25rem;
    color: var(--color-base-content);
  }

  input {
    box-sizing: border-box;
    border-style: solid;
    font-family: inherit;
    margin: 0;
    overflow: visible;
    color: inherit;
    appearance: none;
    background-color: var(--color-base-100);
    border-color: var(--color-base-200);
    border-width: 1px;
    border-radius: var(--radius-field);
    padding-top: 0.75rem;
    padding-right: 1rem;
    padding-bottom: 0.75rem;
    padding-left: 1rem;
    font-size: 1rem;
    line-height: 1.5;
    display: block;
    width: 100%;
    transition-property:
      background-color, border-color, color, fill, stroke, opacity, box-shadow,
      transform;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
  }

  input:focus {
    outline: none;
    box-shadow: 0 0 0 3px var(--color-info);
    border-color: var(--color-info);
  }

  input[type='email'] {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='%239fa6b2'%3E%3Cpath d='M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z' /%3E%3Cpath d='M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z' /%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: left 0.5rem center;
    background-size: 1.5em 1.5em;
    padding-left: 2.5rem;
  }

  input[type='tel'] {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='%239fa6b2'%3E%3Cpath d='M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z' /%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: left 0.5rem center;
    background-size: 1.5em 1.5em;
    padding-left: 2.5rem;
  }

  input[type='submit'] {
    box-sizing: border-box;
    border-style: solid;
    font-family: inherit;
    margin: 0;
    overflow: visible;
    text-transform: none;
    background-image: none;
    cursor: pointer;
    width: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    border-width: 1px;
    border-color: transparent;
    font-size: 1rem;
    font-weight: 700;
    line-height: 1.5rem;
    border-radius: var(--radius-field);
    color: var(--color-primary-content);
    transition-property:
      background-color, border-color, color, fill, stroke, opacity, box-shadow,
      transform;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
  }

  input::placeholder {
    color: var(--color-base-200);
    opacity: 1;
  }

  .hs-form-radio-display {
    font-weight: 400;
    font-size: 1rem;
    color: var(--color-base-content);
  }

  .hs-form-radio {
    display: inline-block;
    margin-right: 2rem;
  }

  input[type='radio'] {
    border: 0 solid var(--color-base-200);
    font-family: inherit;
    font-size: 100%;
    margin: 0;
    overflow: visible;
    line-height: inherit;
    box-sizing: border-box;
    padding: 0;
    appearance: none;
    display: inline-block;
    vertical-align: middle;
    background-origin: border-box;
    user-select: none;
    flex-shrink: 0;
    border-radius: 100%;
    background-color: var(--color-base-100);
    border-color: var(--color-base-200);
    border-width: 1px;
    height: 1rem;
    color: var(--color-primary);
    width: 1rem !important;
    transition-property:
      background-color, border-color, color, fill, stroke, opacity, box-shadow,
      transform;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 0.15s;
    margin-right: 0.75rem;
  }

  input[type='radio']:checked {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 16 16' fill='%23fff' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5.707 7.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 00-1.414-1.414L7 8.586 5.707 7.293z'/%3E%3C/svg%3E");
    border-color: transparent;
    background-color: var(--color-primary);
    background-size: 100% 100%;
    background-position: 50%;
    background-repeat: no-repeat;
  }

  input[type='radio']:checked:focus {
    border-color: transparent;
  }

  input[type='radio']:focus {
    outline: none;
    box-shadow: 0 0 0 3px var(--color-info);
    border-color: var(--color-info);
  }

  textarea {
    box-sizing: border-box;
    border-style: solid;
    font-family: inherit;
    margin: 0;
    overflow: auto;
    resize: vertical;
    color: inherit;
    appearance: none;
    background-color: var(--color-base-100);
    border-color: var(--color-base-200);
    border-width: 1px;
    border-radius: var(--radius-field);
    padding-top: 0.75rem;
    padding-right: 1rem;
    padding-bottom: 0.75rem;
    padding-left: 1rem;
    font-size: 1rem;
    line-height: 1.5;
    display: block;
    width: 100%;
    transition-property:
      background-color, border-color, color, fill, stroke, opacity, box-shadow,
      transform;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
  }

  textarea:focus {
    outline: none;
    box-shadow: 0 0 0 3px var(--color-info);
    border-color: var(--color-info);
  }

  select {
    box-sizing: border-box;
    border: 0 solid var(--color-base-200);
    font-family: inherit;
    margin: 0;
    text-transform: none;
    color: inherit;
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='none'%3E%3Cpath d='M7 7l3-3 3 3m0 6l-3 3-3-3' stroke='%239fa6b2' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
    appearance: none;
    background-repeat: no-repeat;
    background-color: var(--color-base-100);
    border-color: var(--color-base-200);
    border-width: 1px;
    border-radius: var(--radius-field);
    padding-top: 0.75rem;
    padding-right: 1rem;
    padding-bottom: 0.75rem;
    padding-left: 1rem;
    background-position: right 0.5rem center;
    background-size: 1.5em 1.5em;
    display: block;
    width: 100%;
    transition-property:
      background-color, border-color, color, fill, stroke, opacity, box-shadow,
      transform;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 0.15s;
    font-size: 1rem;
    line-height: 1.25rem;
    height: 3.125rem;
  }

  select:focus {
    outline: none;
    box-shadow: 0 0 0 3px var(--color-info);
    border-color: var(--color-info);
  }

  .hs-main-font-element h3 {
    font-weight: 600;
    color: var(--color-base-content);
    margin-top: 2rem;
  }

  .hs-main-font-element p {
    font-size: 0.875rem;
    line-height: 1.25rem;
    color: var(--color-base-content);
    border-bottom: 1px solid var(--color-base-200);
    padding-bottom: 0.5rem;
  }

  input[type='checkbox'] {
    box-sizing: border-box;
    border-style: solid;
    font-family: inherit;
    font-size: 100%;
    margin: 0;
    line-height: inherit;
    appearance: none;
    padding: 0;
    display: inline-block;
    vertical-align: middle;
    background-origin: border-box;
    user-select: none;
    flex-shrink: 0;
    background-color: var(--color-base-100);
    border-width: 1px;
    height: 1rem;
    width: 1rem !important;
    border-radius: var(--radius-field);
    background-color: var(--color-base-100);
    border-color: var(--color-base-200);
    border-width: 1px;
    color: var(--color-primary);
    transition-property:
      background-color, border-color, color, fill, stroke, opacity, box-shadow,
      transform;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 0.15s;
    margin-right: 0.75rem;
  }

  input[type='checkbox']:checked {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 16 16' fill='%23fff' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5.707 7.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 00-1.414-1.414L7 8.586 5.707 7.293z'/%3E%3C/svg%3E");
    border-color: transparent;
    background-color: var(--color-primary);
    background-size: 100% 100%;
    background-position: 50%;
    background-repeat: no-repeat;
  }

  input[type='checkbox']:checked:focus {
    border-color: transparent;
  }

  input[type='checkbox']:focus {
    outline: none;
    box-shadow: 0 0 0 3px var(--color-info);
    border-color: var(--color-info);
  }

  .hs-fieldtype-booleancheckbox {
    display: flex;
    flex-direction: column;
  }

  .hs-fieldtype-booleancheckbox legend {
    order: 2;
    padding-left: 1.75rem;
  }
`;

const blueSubmitButton = css`
  input[type='submit'] {
    background-color: var(--color-primary);
  }

  input[type='submit']:hover {
    background-color: var(--color-primary-dark);
  }

  input[type='submit']:focus {
    outline: 0;
    border-color: var(--color-primary-darker);
    box-shadow: 0 0 0 3px var(--color-info);
  }

  input[type='submit']:active {
    background-color: var(--color-primary-darker);
  }
`;

const purpleSubmitButton = css`
  input[type='submit'] {
    background-color: var(--color-secondary);
  }

  input[type='submit']:hover {
    background-color: var(--color-secondary);
  }

  input[type='submit']:focus {
    outline: 0;
    border-color: var(--color-secondary);
    box-shadow: 0 0 0 3px var(--color-info);
  }

  input[type='submit']:active {
    background-color: var(--color-secondary);
  }
`;

const cyanSubmitButton = css`
  input[type='submit'] {
    background-color: var(--color-info);
  }

  input[type='submit']:hover {
    background-color: var(--color-info);
  }

  input[type='submit']:focus {
    outline: 0;
    border-color: var(--color-info);
    box-shadow: 0 0 0 3px var(--color-info);
  }

  input[type='submit']:active {
    background-color: var(--color-info);
  }
`;

export default function ContactFormStyles(props) {
  const { children, colorTheme } = props;

  return (
    <div
      css={[
        formStyles,
        colorTheme === 'blue' && blueSubmitButton,
        colorTheme === 'cyan' && cyanSubmitButton,
        colorTheme === 'purple' && purpleSubmitButton,
      ]}
    >
      {children}
    </div>
  );
}
